import { render } from "./CoveredCard.vue?vue&type=template&id=f507656c&ts=true"
import script from "./CoveredCard.vue?vue&type=script&lang=ts"
export * from "./CoveredCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__